import { render, staticRenderFns } from "./RatingsActivity.vue?vue&type=template&id=c63349a8"
import script from "./RatingsActivity.vue?vue&type=script&lang=js"
export * from "./RatingsActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports